import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import CoursesPic from "../../../images/LEarntenqirat.png";

const CoursesPicContLTQ = () => {
  return (
    <div className="QL__PG__PGAboutUsSec">
      <Container>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <div className="QL__Sec__PGAboutUsmsg">
              <h1 className="HeadingAll">Learn Ten Qirat</h1>
              <p className="pt-3">
                Learning the ten Qirats the easy way has now been made possible
                with the help of our tutors at LearnQuranQuick. We have made
                sure to hire such tutors that have proven to be quite beneficial
                for their students throughout the years.
                {/* Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergr.
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam
                etaliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum.
                <br />
                <br />
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergr. justo
                duo dolores et ea rebum. Stet clita kasd gubergr. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergr. justo
                duo dolores et ea rebum. Stet clita kasd gubergr.
                */}
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={CoursesPic} alt="image" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default CoursesPicContLTQ;
